import React, { useState, useEffect } from 'react';
import AWS from 'aws-sdk';

const Uploaddel = (filelink) => {

  /*AWS.config.update( {
   region: process.env.REACT_APP_REGION,            // or whatever your bucket region is
   maxRetries: 5,
   accessKeyId: process.env.REACT_APP_ACCESS,
   secretAccessKey: process.env.REACT_APP_SECRET,
  } );*/


  const spacesEndpoint = new AWS.Endpoint(process.env.REACT_APP_DO_ENDPOINT);

  //let s3Bucket = new AWS.S3();
  const s3Bucket = new AWS.S3({endpoint: spacesEndpoint, accessKeyId: process.env.REACT_APP_DO_ACCESS, secretAccessKey: process.env.REACT_APP_DO_SECRET});

  console.log(filelink);

  s3Bucket.deleteObject({
      Bucket: process.env.REACT_APP_DO_BUCKET,
      Key: filelink,
  }, function(err, data) {

      if (err) {
          console.log('Something went wrong');
          return;
      }
  });

}

export default Uploaddel;
